import isElectron from 'is-electron';
import QueryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import styled from 'styled-components';

import LoadingProgress from '../../components/LoadingProgess';
import { CONTEXT_PATH } from '../../env/variables';
import useLessonReplay from '../../hooks/useLessonReplay';
import useSystemReadyWithMonitors from '../../hooks/useSystemReadyWithMonitors';
import {
  setPlayerMode,
  setPlayerRole,
} from '../../store/actions/resources.actions';
import { lessonControllerHeight } from '../../utils/display.util';
import MapSizeContext from '../common-components/MapSizeContext';
import UpperMonitor from './UpperMonitor';
import { colors, dimension } from './WindowConfig';

export interface IS800Props {}
const Container = styled.div`
  display: block;
  & .inputField {
    width: 70px;
    background-color: ${colors.secondary};
    color: ${colors.white};
    border-bottom: solid 1px ${colors.white};
    margin-bottom: 0.5px;
    padding-left: 5px;
  }
`;
const stripPx = (x: any) => x.replace(/px/g, '');
export default function S80(props: IS800Props) {
  const location = useLocation();
  const dispatch = useDispatch();
  //system, trainingUnitId, versionId, mode, role, token
  const {
    mode,
    role,
    system,
    unit,
    token,
    version,
    enrollId,
    attemptType,
    subjectId,
  } = QueryString.parse(location.search);
  const { systemReady, resetSystem } = useSystemReadyWithMonitors(3);
  const { t } = useTranslation();
  useLessonReplay(
    {
      system: `${system}`,
      unit: `${unit}`,
      token: `${token}`,
      version: `${version}`,
      mode: `${mode}`,
      role: `${role}`,
      enrollId: `${enrollId}`,
      attemptType: `${attemptType}`,
      subjectId: `${subjectId}`,
    },
    resetSystem
  );

  const [restartPalyer, setRestartPlayer] = useState({});

  useEffect(() => {
    console.log('S80 starting');
    if (location.pathname === '/s80') {
      //Added a 2 seconds delay before opening the other monitors, Will remove once the resources loading isssue is solved
      if (!isElectron()) {
        setTimeout(() => {
          window.open(
            `${window.location.origin}${CONTEXT_PATH}/app/nots_player/lesson-controller?mode=${mode}&system=s80`,
            `Lesson Controller`,
            `resizable=off,left=1600,top=200,width=400,height=${lessonControllerHeight(
              mode,
              's80'
            )}`
          );
          window.open(
            `${window.location.origin}${CONTEXT_PATH}/app/nots_player/s80/lower?mode=${mode}`,
            `Lower Monitor`,
            `resizable=off,left=200,top=200,width=${stripPx(
              dimension.lowerMonitorSize.width
            )},height=${stripPx(dimension.lowerMonitorSize.height)}`
          );
          window.open(
            `${window.location.origin}${CONTEXT_PATH}/app/nots_player/s80/desk?mode=${mode}`,
            'Desk',
            `resizable=off,left=400,top=400,width=${stripPx(
              dimension.desk.width
            )},height=${stripPx(dimension.desk.height)}`
          );
        }, 2000);
      }
    }
  }, [location.pathname, restartPalyer]);

  useEffect(() => {
    dispatch(setPlayerMode(mode));
    dispatch(setPlayerRole(role));
  }, [mode, role, dispatch]);

  if (!systemReady) {
    return <LoadingProgress message={t('loadingProgress.screenLoad')} />;
  }

  return (
    <Container>
      <MapSizeContext.Provider
        value={{
          width: 1200,
          height: 1100,
        }}
      >
        <Switch>
          <Redirect
            exact
            from="/s80"
            to={{ ...location, pathname: '/s80/upper' }}
            // to="/s80/upper"
          />
          <Route path="/s80/upper" render={() => <UpperMonitor />} />
        </Switch>
      </MapSizeContext.Provider>
    </Container>
  );
}
